module.exports = __webpack_public_path__ + "d31da8ccbd5f351229c3b363987b084b.png";